<template>
  <div
    class="tz-switch"
    @click="toggleCheck"
    :class="{ 'tz-switch--disabled': isDisabled }"
  >
    <div
      class="tz-switch__toggle"
      :class="{
        'tz-switch__toggle--on': isToggled,
        'tz-switch__toggle--off': !isToggled
      }"
    >
      <input
        class="tz-switch__input"
        :name="name"
        type="checkbox"
        :id="name"
        :model="isToggled"
      />
      <span class="tz-switch__slider" aria-hidden="true"></span>
    </div>
    <div class="tz-switch__label" aria-hidden="true">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'TzSwitch',
  props: {
    // Boolean indicating if switch is disabled
    isDisabled: {
      type: Boolean,
      default: false
    },
    // Boolean indicating if switch should be toggled
    isToggled: {
      type: Boolean,
      default: false
    },
    // Label to display on switch
    label: {
      type: String,
      required: true
    },
    // Name to give to switch
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleCheck() {
      // Do nothing on disabled
      if (this.isDisabled) {
        return;
      }

      // Emit event on toggle change
      this.$emit('tz-switch-change');
    }
  }
};
</script>
